import React from 'react'
import PropTypes from 'prop-types'
import isWebview from './isWebview'

const ConditionalWrapper = ({ flag, children, fallbackComponent }) => flag ? children : fallbackComponent

ConditionalWrapper.propTypes = {
    flag: PropTypes.bool,
    fallbackComponent: PropTypes.node,
}

ConditionalWrapper.defaultProps = {
    flag: false,
    fallbackComponent: null
}

const WebviewWrapper = ({flag, children, fallbackComponent}) => <ConditionalWrapper flag={flag} fallbackComponent={fallbackComponent}>{children}</ConditionalWrapper>

WebviewWrapper.propTypes = {
  flag: PropTypes.bool,
  fallbackComponent: PropTypes.node,
  children: PropTypes.any,
}

WebviewWrapper.defaultProps = {
  flag: isWebview()
}

const BrowserWrapper = ({flag, children, fallbackComponent}) => <ConditionalWrapper flag={flag} fallbackComponent={fallbackComponent}>{children}</ConditionalWrapper>

BrowserWrapper.propTypes = {
  flag: PropTypes.bool,
  fallbackComponent: PropTypes.node,
  children: PropTypes.any,
}

BrowserWrapper.defaultProps = {
  flag: !isWebview()
}

export {
  WebviewWrapper,
  BrowserWrapper,
}

export default ConditionalWrapper;

